import React, { useLayoutEffect } from "react";
import _ from "lodash";

import * as am5 from "@amcharts/amcharts5";
import * as am5flow from "@amcharts/amcharts5/flow";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

function SankeyChart({
  id,
  intl,
  data,
  minWidth = "800px",
  minHeigh = "350px",
}) {
  useLayoutEffect(() => {
    var root = am5.Root.new(id);

    // Set themes
    // https://www.amcharts.com/docs/v5/concepts/themes/
    root.setThemes([am5themes_Animated.new(root)]);

    // Create series
    // https://www.amcharts.com/docs/v5/charts/flow-charts/
    var series = root.container.children.push(
      am5flow.Sankey.new(root, {
        sourceIdField: "from",
        targetIdField: "to",
        valueField: "value",
        paddingRight: 150,
        paddingBottom: 50,
        idField: "id",
      })
    );

    series.links.template.setAll({ fillStyle: "source", fillOpacity: 0.15 });

    // highlight all links with the same id beginning
    series.links.template.events.on("pointerover", function (event) {
      var dataItem = event.target.dataItem;
      var id = dataItem.get("id").split("-")[0];

      am5.array.each(series.dataItems, function (dataItem) {
        if (dataItem.get("id").indexOf(id) != -1) {
          dataItem.get("link").hover();
        }
      });
    });

    series.links.template.events.on("pointerout", function (event) {
      am5.array.each(series.dataItems, function (dataItem) {
        dataItem.get("link").unhover();
      });
    });

    // Set data
    // https://www.amcharts.com/docs/v5/charts/flow-charts/#Setting_data

    const statusMap = {
      A: "Preparazione",
      B: "Progettazione",
      C: "Esecuzione",
      D: "Chiusura",
      E: "Preventivati",
      F: "Non preventivati",
      G: "Preventivati accettati",
      H: "Preventivati in attesa",
      I: "Preventivati rifiutati",
      J: "Vinti",
      K: "Persi",
    };

    const parseData = () => {
      let keys = Object.keys(data);
      let results = [];

      keys.forEach((key, i) => {
        let value = data[key].count;
        let percentage = data[key].percentage;
        let from = key.split("-")[0];
        let to = key.split("-")[1];
        results.push({ from, to, value, id: `${from}${i}`, percentage });
      });

      return results;
    };

    let sankeyData = parseData();

    series.data.setAll(
      sankeyData.map((d) => {
        return {
          ...d,
          from: statusMap[d.from] || d.from,
          to: statusMap[d.to] || d.to,
        };
      })
    );


    series.nodes.labels.template.setAll({
      text: "[bold]{name}[/]\n{sumIncoming} → {sumOutgoing}",
      y: am5.percent(0),
      centerY: am5.percent(0),
      paddingTop: 2,
      paddingRight: 0,
      paddingBottom: 2,
    });
    series.links.template.setAll({
      tooltipText: "{sourceId} - {targetId}: [bold]{value}[/] ({percentage}%)",
    });

    // Make stuff animate on load
    series.appear(1000, 100);

    return () => {
      root.dispose();
    };
  }, [data, id]); // eslint-disable-line react-hooks/exhaustive-deps

  return <div id={id} style={{ minWidth: minWidth, minHeight: minHeigh}} />;
}

export default React.memo(SankeyChart, (props, nextProps) => {
  return _.isEqual(props.data, nextProps.data);
});
